import _ from "lodash";
import * as monaco from "monaco-editor";
import store from "../../../../store";
// Monaco dil desteği ve otomatik tamamlama için Chatbot SDK'sını tanımlama
export const createCompletionItemProviderForChatbot = (chatbotAttributes = [], moduleCache = []) => {
    if (Array.isArray(moduleCache) && moduleCache.length === 0) {
        moduleCache = store.state.module.modules || [];
    }
    const tables = store.state.table.tables || [];

    console.log("createCompletionItemProviderForChatbot-> moduleCache", { moduleCache });
    return {
        triggerCharacters: ["."], // Nokta karakterinde otomatik tetikle
        provideCompletionItems: function (model, position) {
            const textUntilPosition = model.getValueInRange({
                startLineNumber: position.lineNumber,
                startColumn: 1,
                endLineNumber: position.lineNumber,
                endColumn: position.column,
            });

            const lastWordMatch = textUntilPosition.match(/[\w\d.$]+$/);
            const lastWord = lastWordMatch ? lastWordMatch[0] : "";

            // Global değişken önerileri (chatbot, supsis, moment, _, axios)
            if (!lastWord || !lastWord.includes(".")) {
                const globalSuggestions = [
                    {
                        label: "chatbot",
                        kind: monaco.languages.CompletionItemKind.Variable,
                        insertText: "chatbot",
                        detail: "Chatbot SDK",
                        documentation: "Chatbot özel metodları ve özellikleri (sendMessage, close, transfer, vb.)",
                        sortText: "0_chatbot", // Öncelikli göster
                    },
                    {
                        label: "supsis",
                        kind: monaco.languages.CompletionItemKind.Variable,
                        insertText: "supsis",
                        detail: "Supsis SDK",
                        documentation: "Supsis platform API'sine erişim (users, contact, task, module, vb.)",
                        sortText: "0_supsis", // Öncelikli göster
                    },
                    {
                        label: "moment",
                        kind: monaco.languages.CompletionItemKind.Variable,
                        insertText: "moment",
                        detail: "Moment.js",
                        documentation: "Tarih ve saat işlemleri için kütüphane",
                        sortText: "1_moment",
                    },
                    {
                        label: "_",
                        kind: monaco.languages.CompletionItemKind.Variable,
                        insertText: "_",
                        detail: "Lodash",
                        documentation: "Veri işleme ve dizi/obje manipülasyonu için kütüphane",
                        sortText: "1_lodash",
                    },
                    {
                        label: "axios",
                        kind: monaco.languages.CompletionItemKind.Variable,
                        insertText: "axios",
                        detail: "Axios HTTP Client",
                        documentation: "HTTP istekleri için kütüphane (get, post, put, delete)",
                        sortText: "1_axios",
                    },
                ];

                // Eğer kelime yazılmaya başlandıysa filtrele
                if (lastWord) {
                    const filtered = globalSuggestions.filter((s) =>
                        s.label.toLowerCase().startsWith(lastWord.toLowerCase())
                    );
                    if (filtered.length > 0) {
                        return { suggestions: filtered };
                    }
                }

                // Hiç kelime yoksa tüm global değişkenleri göster
                return { suggestions: globalSuggestions };
            }

            // Chatbot attribute önerileri
            if (lastWord && lastWord.startsWith("block.")) {
                const matchingAttrs = chatbotAttributes
                    .filter((attr) => attr.value && attr.value.startsWith(lastWord))
                    .map((attr) => ({
                        label: attr.name || attr.value,
                        kind: monaco.languages.CompletionItemKind.Variable,
                        insertText: attr.value.substring(lastWord.length),
                        detail: attr.value,
                        documentation: `Chatbot Attribute\nTip: ${attr.type || "string"}`,
                    }));

                if (matchingAttrs.length > 0) {
                    return { suggestions: matchingAttrs };
                }
            }

            // Supsis SDK AutoComplete (supsis yazıldığında veya supsis. yazıldığında)
            const supsisMatch = lastWord === "supsis" || lastWord === "supsis.";
            if (supsisMatch) {
                const modules = [
                    {
                        label: "users",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "users",
                        detail: "Supsis Kullanıcı Modülü",
                        documentation: "Kullanıcı işlemleri için API modülü",
                    },
                    {
                        label: "ticket",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "ticket",
                        detail: "Supsis Bilet Modülü",
                        documentation: "Bilet işlemleri için API modülü",
                    },
                    {
                        label: "task",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "task",
                        detail: "Supsis Görev Modülü",
                        documentation: "Görev işlemleri için API modülü",
                    },
                    {
                        label: "contact",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "contact",
                        detail: "Supsis Kişi Modülü",
                        documentation: "Kişi işlemleri için API modülü",
                    },
                    {
                        label: "activity",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "activity",
                        detail: "Supsis Aktivite Modülü",
                        documentation: "Özel aktivite kayıtları için API modülü",
                    },
                    {
                        label: "whatsapp",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "whatsapp",
                        detail: "Supsis WhatsApp Modülü",
                        documentation: "WhatsApp işlemleri için API modülü",
                    },
                    {
                        label: "chat",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "chat",
                        detail: "Supsis Chat Modülü",
                        documentation: "Chat işlemleri için API modülü",
                    },
                    {
                        label: "message",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "message",
                        detail: "Supsis Mesaj Modülü",
                        documentation: "Mesaj işlemleri için API modülü",
                    },
                    {
                        label: "form",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "form",
                        detail: "Supsis Form Modülü",
                        documentation: "Form işlemleri için API modülü",
                    },
                    {
                        label: "channel",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "channel",
                        detail: "Supsis Kanal Modülü",
                        documentation: "Kanal işlemleri için API modülü",
                    },
                    {
                        label: "zoho",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "zoho",
                        detail: "Supsis Zoho CRM Modülü",
                        documentation: "Zoho CRM entegrasyonu için API modülü",
                    },
                    {
                        label: "sms",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "sms",
                        detail: "Supsis SMS Modülü",
                        documentation: "SMS gönderimi için API modülü",
                    },
                    {
                        label: "email",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "email",
                        detail: "Supsis Email Modülü",
                        documentation: "Email gönderimi için API modülü",
                    },
                    {
                        label: "report",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "report",
                        detail: "Supsis Rapor Modülü",
                        documentation: "Raporlama işlemleri için API modülü",
                    },
                    {
                        label: "module",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "module",
                        detail: "Supsis Modül Erişimi",
                        documentation: "Modüller ve özel tablolar için API erişimi",
                    },
                    {
                        label: "asset",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "asset",
                        detail: "Supsis Asset Modülü",
                        documentation: "Dosya ve medya yönetimi için API modülü",
                    },
                    {
                        label: "util",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "util",
                        detail: "Supsis Utility Modülü",
                        documentation: "Yardımcı fonksiyonlar için API modülü",
                    },
                    {
                        label: "balance",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "balance",
                        detail: "Supsis Bakiye Modülü",
                        documentation: "Cüzdan bakiye işlemleri için API modülü",
                    },
                    {
                        label: "ikas",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "ikas",
                        detail: "Supsis İkas Modülü",
                        documentation: "İkas e-ticaret entegrasyonu için API modülü",
                    },
                    {
                        label: "voiceagent",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "voiceagent",
                        detail: "Supsis Voice Agent Modülü",
                        documentation: "Yapay zeka sesli arama için API modülü",
                    },
                    {
                        label: "queue",
                        kind: monaco.languages.CompletionItemKind.Module,
                        insertText: "queue",
                        detail: "Supsis Kuyruk Modülü",
                        documentation: "İşlem kuyruğu yönetimi için API modülü",
                    },
                ];
                return { suggestions: modules };
            }

            // Chatbot özel metodları (chatbot yazıldığında veya chatbot. yazıldığında)
            const chatbotMatch = lastWord === "chatbot" || lastWord === "chatbot.";
            if (chatbotMatch) {
                return {
                    suggestions: [
                        {
                            label: "readAttribute",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "readAttribute(${1:key}, ${2:defaultValue})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Attribute okur",
                            documentation: "Chatbot state'inden attribute değerini okur",
                        },
                        {
                            label: "bindAttribute",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "bindAttribute(${1:data})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Attribute binding yapar",
                            documentation: "String içindeki {{attribute}} değişkenlerini replace eder",
                        },
                        {
                            label: "currentChatId",
                            kind: monaco.languages.CompletionItemKind.Property,
                            insertText: "currentChatId",
                            detail: "Mevcut sohbet ID'si",
                            documentation: "Şu anki conversation ID'sini döndürür",
                        },
                        {
                            label: "visitorId",
                            kind: monaco.languages.CompletionItemKind.Property,
                            insertText: "visitorId",
                            detail: "Ziyaretçi ID'si",
                            documentation: "Şu anki ziyaretçi/kişi ID'sini döndürür",
                        },
                        {
                            label: "whatsappNumber",
                            kind: monaco.languages.CompletionItemKind.Property,
                            insertText: "whatsappNumber",
                            detail: "WhatsApp telefon numarası",
                            documentation: "Kullanıcının telefon numarası (phone attribute)",
                        },
                        {
                            label: "channelId",
                            kind: monaco.languages.CompletionItemKind.Property,
                            insertText: "channelId",
                            detail: "Kanal ID'si",
                            documentation: "Mevcut kanalın ID'si",
                        },
                        {
                            label: "platform",
                            kind: monaco.languages.CompletionItemKind.Property,
                            insertText: "platform",
                            detail: "Platform tipi",
                            documentation: "Kullanıcının bağlandığı platform (web, whatsapp, instagram, vb.)",
                        },
                        {
                            label: "close",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "close()",
                            detail: "Sohbeti kapat",
                            documentation: "Mevcut sohbeti kapatır",
                        },
                        {
                            label: "transfer",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "transfer()",
                            detail: "Canlı desteğe aktar",
                            documentation: "Sohbeti canlı destek ekibine aktarır",
                        },
                        {
                            label: "sendMessage",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "sendMessage(${1:message}, ${2:'text'})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Mesaj gönder",
                            documentation: "Kullanıcıya mesaj gönderir. type: 'text', 'private' olabilir",
                        },
                        {
                            label: "sendTyping",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "sendTyping()",
                            detail: "Yazıyor göstergesi gönder",
                            documentation: "Kullanıcıya 'yazıyor...' göstergesi gönderir",
                        },
                        {
                            label: "setAttributes",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "setAttributes({\n\t${1:key}: ${2:value}\n})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Attribute güncelle",
                            documentation: "Chatbot state'ine attribute ekler veya günceller",
                        },
                        {
                            label: "jump",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "jump(${1:blockId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Belirli bloğa atla",
                            documentation: "Chatbot akışını belirtilen blok ID'sine yönlendirir",
                        },
                        {
                            label: "gotoDefaultFallback",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "gotoDefaultFallback()",
                            detail: "Default fallback'e git",
                            documentation: "Chatbot akışını default fallback bloğuna yönlendirir",
                        },
                        {
                            label: "askAssistant",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "askAssistant(${1:message})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "AI asistana sor",
                            documentation:
                                "Yapay zeka asistanına mesaj gönderir ve cevabını döndürür (kullanıcıya mesaj gönderilmez)",
                        },
                        {
                            label: "getState",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "getState()",
                            detail: "Chatbot state'ini döndürür",
                            documentation: "Tüm chatbot state'ini (attributes, history, vb.) döndürür",
                        },
                        {
                            label: "getMessages",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "getMessages()",
                            detail: "Mesaj geçmişini getirir",
                            documentation: "Sohbetteki tüm mesajları getirir",
                        },
                        {
                            label: "forwardToAnotherChatbot",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'forwardToAnotherChatbot({\n\tstoryId: "${1:targetStoryId}",\n\tforwardAllAttributes: ${2:true},\n\tcustomAttributes: ${3:{}},\n\tinitialBlockId: "${4:}",\n\trunAIFirstForce: ${5:false},\n\taiTriggerMessage: "${6:}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Başka chatbot'a yönlendir",
                            documentation: "Kullanıcıyı başka bir chatbot'a yönlendirir",
                        },
                    ],
                };
            }

            // users. alt metodları (supsis.users yazıldığında veya supsis.users. yazıldığında)
            const usersMatch = lastWord === "supsis.users" || lastWord === "supsis.users.";
            if (usersMatch) {
                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:id})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kullanıcı bilgilerini getirir",
                            documentation: "Kullanıcı ID'sine göre kullanıcı bilgilerini getirir",
                        },
                        {
                            label: "list",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "list()",
                            detail: "Kullanıcı listesini döndürür",
                            documentation: "Sistemdeki tüm kullanıcıların listesini döndürür",
                        },
                    ],
                };
            }

            // contact. alt metodları (supsis.contact yazıldığında veya supsis.contact. yazıldığında)
            const contactMatch = lastWord === "supsis.contact" || lastWord === "supsis.contact.";
            if (contactMatch) {
                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:contactId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kişi detaylarını getirir",
                            documentation: "Kişi ID'sine göre detayları getirir",
                        },
                        {
                            label: "create",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'create({\n\tplatform: "${1:supsis}",\n\tfullname: "${2:Ad Soyad}",\n\temail: "${3:email@example.com}",\n\tphone: "${4:5551234567}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yeni kişi oluşturur",
                            documentation: "Yeni kişi kaydı oluşturur",
                        },
                        {
                            label: "update",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "update(${1:contactId}, {\n\t${2:field}: ${3:value}\n})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kişi günceller",
                            documentation: "Var olan bir kişiyi günceller",
                        },
                        {
                            label: "addTag",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "addTag(${1:contactId}, ${2:tagId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Etiket ekler",
                            documentation: "Kişiye etiket ekler",
                        },
                        {
                            label: "removeTag",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "removeTag(${1:contactId}, ${2:tagId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Etiket kaldırır",
                            documentation: "Kişiden etiket kaldırır",
                        },
                        {
                            label: "updateContactProperty",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "updateContactProperty(${1:contactId}, ${2:propertyName}, ${3:value})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kişi özel alanını günceller",
                            documentation: "Kişinin contact property alanını günceller",
                        },
                        {
                            label: "changeOwnerAuto",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'changeOwnerAuto(${1:contactId}, {\n\tcheckOnlineStatus: ${2:false},\n\talgorithm: "${3:least_contact}",\n\tdateRange: "${4:today}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Otomatik sahiplik ataması",
                            documentation: "Kişi sahipliğini otomatik algoritma ile değiştirir",
                        },
                        {
                            label: "changeOwner",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "changeOwner(${1:contactId}, ${2:ownerId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Sahiplik değiştir",
                            documentation: "Kişi sahipliğini belirli kullanıcıya atar",
                        },
                        {
                            label: "search",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'search({\n\toperator: "${1:and}",\n\tgroups: [{\n\t\toperator: "${2:and}",\n\t\tfilters: [{\n\t\t\trule: "${3:contains}",\n\t\t\tattribute: "${4:fullname}",\n\t\t\tvalue: "${5:value}"\n\t\t}]\n\t}]\n}, {\n\toffset: ${6:0},\n\tlimit: ${7:10}\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kişi arar",
                            documentation: "Filtrelere göre kişi arar",
                        },
                    ],
                };
            }

            // ticket. alt metodları
            const ticketMatch = lastWord === "supsis.ticket" || lastWord === "supsis.ticket.";
            if (ticketMatch) {
                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:id})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Bilet detaylarını getirir",
                            documentation: "Bilet ID'sine göre detayları getirir",
                        },
                        {
                            label: "create",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'create({\n\tcontactId: ${1:contactId},\n\ttag: "${2:chatbot}",\n\tsubject: "${3:Konu}",\n\tmessage: "${4:Mesaj}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yeni bilet oluşturur",
                            documentation: "Yeni bilet kaydı oluşturur",
                        },
                        {
                            label: "update",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "update(${1:ticketId}, {\n\t${2:field}: ${3:value}\n})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Bilet günceller",
                            documentation: "Bileti günceller",
                        },
                    ],
                };
            }

            // task. alt metodları
            const taskMatch = lastWord === "supsis.task" || lastWord === "supsis.task.";
            if (taskMatch) {
                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:id})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Görev detaylarını getirir",
                            documentation: "Görev ID'sine göre detayları getirir",
                        },
                        {
                            label: "create",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'create({\n\tworkflowId: "${1:workflowId}",\n\tpipelineStageId: "${2:pipelineStageId}",\n\ttitle: "${3:Başlık}",\n\tdescription: "${4:Açıklama}",\n\tpriority: "${5:medium}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yeni görev oluşturur",
                            documentation: "Yeni görev kaydı oluşturur",
                        },
                        {
                            label: "update",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "update(${1:taskId}, {\n\t${2:field}: ${3:value}\n})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Görev günceller",
                            documentation: "Görevi günceller",
                        },
                        {
                            label: "move",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "move(${1:taskId}, ${2:pipelineName})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Görev taşır",
                            documentation: "Görevi başka pipeline'a taşır",
                        },
                        {
                            label: "search",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "search(${1:workflowId}, ${2:filters}, ${3:cursor})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Görev arar",
                            documentation: "Görev araması yapar",
                        },
                    ],
                };
            }

            // zoho. alt metodları
            const zohoMatch = lastWord === "supsis.zoho" || lastWord === "supsis.zoho.";
            if (zohoMatch) {
                return {
                    suggestions: [
                        {
                            label: "getDealsByPhone",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getDealsByPhone("${1:905551234567}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Telefon numarasına göre anlaşmaları getirir",
                            documentation: "Zoho CRM'de telefon numarasına göre anlaşmaları arar",
                        },
                        {
                            label: "getUserById",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getUserById("${1:userId}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kullanıcı bilgilerini getirir",
                            documentation: "Zoho kullanıcı detaylarını getirir",
                        },
                        {
                            label: "getAllUsers",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "getAllUsers()",
                            detail: "Tüm kullanıcıları listeler",
                            documentation: "Zoho CRM'deki tüm kullanıcıları listeler",
                        },
                        {
                            label: "getContactByPhone",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getContactByPhone("${1:905551234567}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Telefon ile kişi bulur",
                            documentation: "Telefon numarasına göre kişi arar",
                        },
                        {
                            label: "getContactByMobile",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getContactByMobile("${1:905551234567}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Mobil ile kişi bulur",
                            documentation: "Mobil telefon numarasına göre kişi arar",
                        },
                        {
                            label: "createContact",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'createContact("${1:Ahmet Yılmaz}", "${2:905551234567}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yeni kişi oluşturur",
                            documentation: "Zoho CRM'de yeni kişi oluşturur",
                        },
                        {
                            label: "createLead",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'createLead("${1:Ahmet Yılmaz}", "${2:905551234567}", {\n\t${3:Company}: "${4:Acme Corp}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yeni lead oluşturur",
                            documentation: "Zoho CRM'de yeni lead oluşturur",
                        },
                        {
                            label: "getLeadByPhone",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getLeadByPhone("${1:905551234567}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Telefon ile lead bulur",
                            documentation: "Telefon numarasına göre lead arar",
                        },
                        {
                            label: "getLeadById",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getLeadById("${1:leadId}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Lead bilgilerini getirir",
                            documentation: "Lead ID'sine göre detayları getirir",
                        },
                        {
                            label: "getContactById",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getContactById("${1:contactId}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kişi bilgilerini getirir",
                            documentation: "Kişi ID'sine göre detayları getirir",
                        },
                        {
                            label: "createRecord",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'createRecord("${1:Deals}", {\n\t${2:Deal_Name}: "${3:Yeni Anlaşma}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yeni kayıt oluşturur",
                            documentation: "Zoho modülünde yeni kayıt oluşturur",
                        },
                        {
                            label: "updateRecord",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'updateRecord("${1:Leads}", "${2:recordId}", {\n\t${3:field}: ${4:value}\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kayıt günceller",
                            documentation: "Zoho modülünde kayıt günceller",
                        },
                        {
                            label: "getRecordById",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getRecordById("${1:Contacts}", "${2:recordId}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kayıt getirir",
                            documentation: "Zoho modülünden kayıt getirir",
                        },
                        {
                            label: "getModules",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "getModules()",
                            detail: "Modülleri listeler",
                            documentation: "Zoho CRM modüllerini listeler",
                        },
                        {
                            label: "getModuleFields",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getModuleFields("${1:Contacts}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Modül alanlarını getirir",
                            documentation: "Zoho modülünün alanlarını getirir",
                        },
                        {
                            label: "isNewLeadByPhone",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'isNewLeadByPhone("${1:905551234567}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yeni lead kontrolü",
                            documentation: "Telefon numarasının yeni lead olup olmadığını kontrol eder",
                        },
                    ],
                };
            }

            // whatsapp. alt metodları
            const whatsappMatch = lastWord === "supsis.whatsapp" || lastWord === "supsis.whatsapp.";
            if (whatsappMatch) {
                return {
                    suggestions: [
                        {
                            label: "sendTemplateMessage",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'sendTemplateMessage({\n\tchannelId: "${1:channelId}",\n\ttemplate: ${2:templateObj},\n\tphoneNumber: "${3:905xxxxxxxxx}",\n\tparams: ${4:[]}\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "WhatsApp şablon mesajı gönderir",
                            documentation: "WhatsApp şablon mesajı gönderir",
                        },
                        {
                            label: "getTemplate",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'getTemplate({\n\tchannelId: "${1:channelId}",\n\ttemplateId: "${2:templateId}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "WhatsApp şablon bilgisi getirir",
                            documentation: "WhatsApp şablon bilgilerini getirir",
                        },
                        {
                            label: "qr",
                            kind: monaco.languages.CompletionItemKind.Module,
                            insertText: "qr",
                            detail: "WhatsApp QR alt modülü",
                            documentation: "WhatsApp QR kanalı metodları",
                        },
                    ],
                };
            }

            // whatsapp.qr. alt metodları
            const whatsappQRMatch = lastWord === "supsis.whatsapp.qr" || lastWord === "supsis.whatsapp.qr.";
            if (whatsappQRMatch) {
                return {
                    suggestions: [
                        {
                            label: "send",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'send({\n\tchannelId: "${1:channelId}",\n\tphoneNumber: "${2:905xxxxxxxxx}",\n\tmessage: "${3:Merhaba}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "WhatsApp QR mesaj gönderir",
                            documentation: "WhatsApp QR kanalından mesaj gönderir",
                        },
                        {
                            label: "sendLocation",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'sendLocation({\n\tchannelId: "${1:channelId}",\n\tphoneNumber: "${2:905xxxxxxxxx}",\n\tlocation: { lat: ${3:41.0082}, lng: ${4:28.9784} }\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "WhatsApp konum gönderir",
                            documentation: "WhatsApp QR kanalından konum gönderir",
                        },
                    ],
                };
            }

            // channel. alt metodları
            const channelMatch = lastWord === "supsis.channel" || lastWord === "supsis.channel.";
            if (channelMatch) {
                return {
                    suggestions: [
                        {
                            label: "list",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "list()",
                            detail: "Kanalları listeler",
                            documentation: "Tüm kanalları listeler",
                        },
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'get("${1:channelId}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kanal bilgisi getirir",
                            documentation: "Kanal ID'sine göre detayları getirir",
                        },
                        {
                            label: "getByType",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getByType("${1:whatsapp-business-api}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Tipe göre kanalları getirir",
                            documentation: "Belirli tipteki kanalları listeler",
                        },
                    ],
                };
            }

            // sms. alt metodları
            const smsMatch = lastWord === "supsis.sms" || lastWord === "supsis.sms.";
            if (smsMatch) {
                return {
                    suggestions: [
                        {
                            label: "send",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'send({\n\tchannelId: "${1:channelId}",\n\tsenderId: "${2:senderId}",\n\tnumber: "${3:905xxxxxxxxx}",\n\tmessage: "${4:Mesaj}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "SMS gönderir",
                            documentation: "SMS gönderir",
                        },
                    ],
                };
            }

            // email. alt metodları
            const emailMatch = lastWord === "supsis.email" || lastWord === "supsis.email.";
            if (emailMatch) {
                return {
                    suggestions: [
                        {
                            label: "send",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'send({\n\tfrom: "${1:destek@sirket.com}",\n\tto: "${2:musteri@example.com}",\n\tsubject: "${3:Konu}",\n\tcontent: "${4:İçerik}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Email gönderir",
                            documentation: "Email gönderir",
                        },
                    ],
                };
            }

            // ikas. alt metodları
            const ikasMatch = lastWord === "supsis.ikas" || lastWord === "supsis.ikas.";
            if (ikasMatch) {
                return {
                    suggestions: [
                        {
                            label: "product",
                            kind: monaco.languages.CompletionItemKind.Module,
                            insertText: "product",
                            detail: "İkas Ürün modülü",
                            documentation: "İkas ürün işlemleri",
                        },
                        {
                            label: "customer",
                            kind: monaco.languages.CompletionItemKind.Module,
                            insertText: "customer",
                            detail: "İkas Müşteri modülü",
                            documentation: "İkas müşteri işlemleri",
                        },
                        {
                            label: "order",
                            kind: monaco.languages.CompletionItemKind.Module,
                            insertText: "order",
                            detail: "İkas Sipariş modülü",
                            documentation: "İkas sipariş işlemleri",
                        },
                    ],
                };
            }

            // ikas.product. alt metodları
            const ikasProductMatch = lastWord === "supsis.ikas.product" || lastWord === "supsis.ikas.product.";
            if (ikasProductMatch) {
                return {
                    suggestions: [
                        {
                            label: "list",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'list("${1:channelId}", {\n\tpage: ${2:1},\n\tlimit: ${3:20}\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Ürün listesi getirir",
                            documentation: "İkas ürün listesini getirir",
                        },
                        {
                            label: "search",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'search("${1:channelId}", {\n\tsearch: "${2:arama}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Ürün arar",
                            documentation: "İkas'ta ürün araması yapar",
                        },
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'get("${1:channelId}", "${2:productId}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Ürün detayı getirir",
                            documentation: "İkas ürün detaylarını getirir",
                        },
                    ],
                };
            }

            // ikas.customer. alt metodları
            const ikasCustomerMatch = lastWord === "supsis.ikas.customer" || lastWord === "supsis.ikas.customer.";
            if (ikasCustomerMatch) {
                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'get("${1:channelId}", "${2:email@example.com}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Müşteri bilgisi getirir",
                            documentation: "İkas müşteri bilgilerini email/telefon ile getirir",
                        },
                    ],
                };
            }

            // ikas.order. alt metodları
            const ikasOrderMatch = lastWord === "supsis.ikas.order" || lastWord === "supsis.ikas.order.";
            if (ikasOrderMatch) {
                return {
                    suggestions: [
                        {
                            label: "getOrderStatus",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getOrderStatus("${1:channelId}", "${2:orderNumber}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Sipariş durumu getirir",
                            documentation: "İkas sipariş durumunu getirir",
                        },
                        {
                            label: "getCustomerOrders",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getCustomerOrders("${1:channelId}", "${2:email@example.com}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Müşteri siparişlerini getirir",
                            documentation: "İkas müşteri siparişlerini getirir",
                        },
                    ],
                };
            }

            // asset. alt metodları
            const assetMatch = lastWord === "supsis.asset" || lastWord === "supsis.asset.";
            if (assetMatch) {
                return {
                    suggestions: [
                        {
                            label: "create",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'create("${1:https://example.com/file.pdf}", "${2:file}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Asset oluşturur",
                            documentation: "URL'den asset oluşturur (file, image, video, audio)",
                        },
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:assetId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Asset bilgisi getirir",
                            documentation: "Asset detaylarını getirir",
                        },
                    ],
                };
            }

            // util. alt metodları
            const utilMatch = lastWord === "supsis.util" || lastWord === "supsis.util.";
            if (utilMatch) {
                return {
                    suggestions: [
                        {
                            label: "html2md",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'html2md("${1:<h1>HTML</h1>}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "HTML'i markdown'a çevirir",
                            documentation: "HTML'i markdown formatına çevirir",
                        },
                        {
                            label: "url2md",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'url2md("${1:https://example.com}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "URL'i markdown'a çevirir",
                            documentation: "URL'den içerik alıp markdown'a çevirir",
                        },
                        {
                            label: "encodeUri",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'encodeUri("${1:text}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "URI encode eder",
                            documentation: "String'i URL-safe formata çevirir",
                        },
                        {
                            label: "decodeUri",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'decodeUri("${1:encoded}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "URI decode eder",
                            documentation: "URL-safe formatından normal string'e çevirir",
                        },
                    ],
                };
            }

            // voiceagent. alt metodları
            const voiceagentMatch = lastWord === "supsis.voiceagent" || lastWord === "supsis.voiceagent.";
            if (voiceagentMatch) {
                return {
                    suggestions: [
                        {
                            label: "makeCall",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'makeCall({\n\tagentId: "${1:agentId}",\n\tfromNumber: "${2:905551234567}",\n\ttoNumber: "${3:905559876543}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yapay zeka araması başlatır",
                            documentation: "Voice agent ile arama başlatır",
                        },
                        {
                            label: "getCall",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getCall("${1:callId}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Arama kaydını getirir",
                            documentation: "Voice agent arama kaydını getirir",
                        },
                    ],
                };
            }

            // queue. alt metodları
            const queueMatch = lastWord === "supsis.queue" || lastWord === "supsis.queue.";
            if (queueMatch) {
                return {
                    suggestions: [
                        {
                            label: "add",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'add(async () => {\n\t${1:// İşlem}\n}, "${2:job_type}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kuyruğa iş ekler",
                            documentation: "Kuyruğa asenkron iş ekler",
                        },
                        {
                            label: "clean",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'clean("${1:job_type}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kuyruğu temizler",
                            documentation: "Belirli tip işleri temizler",
                        },
                        {
                            label: "status",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'status("${1:job_type}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kuyruk durumunu getirir",
                            documentation: "Kuyruk durumu ve istatistiklerini getirir",
                        },
                    ],
                };
            }

            // chat. alt metodları
            const chatMatch = lastWord === "supsis.chat" || lastWord === "supsis.chat.";
            if (chatMatch) {
                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:chatId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Chat kaydını getirir",
                            documentation: "Chat ID'sine göre detayları getirir",
                        },
                    ],
                };
            }

            // message. alt metodları
            const messageMatch = lastWord === "supsis.message" || lastWord === "supsis.message.";
            if (messageMatch) {
                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:messageId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Mesaj kaydını getirir",
                            documentation: "Message ID'sine göre detayları getirir",
                        },
                        {
                            label: "findByExternalProviderId",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "findByExternalProviderId(${1:externalProviderId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "External Provider ID ile bulur",
                            documentation: "External Provider ID'sine göre mesaj arar",
                        },
                        {
                            label: "findByMetaMessageId",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "findByMetaMessageId(${1:metaMessageId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Meta Message ID ile bulur",
                            documentation: "Meta Message ID'sine göre mesaj arar",
                        },
                    ],
                };
            }

            // form. alt metodları
            const formMatch = lastWord === "supsis.form" || lastWord === "supsis.form.";
            if (formMatch) {
                return {
                    suggestions: [
                        {
                            label: "getSubmission",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: 'getSubmission("${1:submissionId}")',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Form submission getirir",
                            documentation: "Form submission cevaplarını getirir",
                        },
                    ],
                };
            }

            // activity. alt metodları
            const activityMatch = lastWord === "supsis.activity" || lastWord === "supsis.activity.";
            if (activityMatch) {
                return {
                    suggestions: [
                        {
                            label: "create",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'create({\n\tmessage: "${1:Mesaj}",\n\tnotification: {\n\t\tconfig: { web: true, email: true }\n\t}\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Aktivite oluşturur",
                            documentation: "Özel aktivite kaydı oluşturur",
                        },
                    ],
                };
            }

            // balance. alt metodları
            const balanceMatch = lastWord === "supsis.balance" || lastWord === "supsis.balance.";
            if (balanceMatch) {
                return {
                    suggestions: [
                        {
                            label: "addActivity",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "addActivity(${1:channelId}, ${2:amount}, ${3:description})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Bakiye aktivitesi ekler",
                            documentation: "Bakiye aktivitesi ekler",
                        },
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:channelId})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Bakiye bilgisi getirir",
                            documentation: "Bakiye bilgilerini getirir",
                        },
                    ],
                };
            }

            // report. alt metodları
            const reportMatch = lastWord === "supsis.report" || lastWord === "supsis.report.";
            if (reportMatch) {
                return {
                    suggestions: [
                        {
                            label: "sessionOverall",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'sessionOverall({\n\tstartDate: "${1:2024-06-01}",\n\tendDate: "${2:2024-06-30}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Session raporu",
                            documentation: "Oturum raporu getirir",
                        },
                        {
                            label: "ratingOverall",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'ratingOverall({\n\tstartDate: "${1:2024-06-01}",\n\tendDate: "${2:2024-06-30}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Rating raporu",
                            documentation: "Puanlama raporu getirir",
                        },
                        {
                            label: "chatDistributionsAll",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                'chatDistributionsAll({\n\tstartDate: "${1:2024-06-01}",\n\tendDate: "${2:2024-06-30}"\n})',
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Chat dağılım raporu",
                            documentation: "Chat dağılım raporu getirir",
                        },
                    ],
                };
            }

            // moment. metodları (moment yazıldığında veya moment. yazıldığında)
            const momentMatch = lastWord === "moment" || lastWord === "moment.";
            if (momentMatch) {
                return {
                    suggestions: [
                        {
                            label: "format",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "format(${1:'YYYY-MM-DD'})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Tarih formatlar",
                            documentation: "Moment nesnesini belirtilen formatta string'e dönüştürür",
                        },
                        {
                            label: "add",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "add(${1:7}, ${2:'days'})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Tarih ekle",
                            documentation: "Tarihe belirtilen süreyi ekler",
                        },
                        {
                            label: "subtract",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "subtract(${1:7}, ${2:'days'})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Tarih çıkar",
                            documentation: "Tarihten belirtilen süreyi çıkarır",
                        },
                        {
                            label: "diff",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "diff(${1:date}, ${2:'days'})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Tarih farkı",
                            documentation: "İki tarih arasındaki farkı hesaplar",
                        },
                        {
                            label: "isBefore",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "isBefore(${1:date})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Öncesinde mi",
                            documentation: "Tarihin belirtilen tarihten önce olup olmadığını kontrol eder",
                        },
                        {
                            label: "isAfter",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "isAfter(${1:date})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Sonrasında mı",
                            documentation: "Tarihin belirtilen tarihten sonra olup olmadığını kontrol eder",
                        },
                    ],
                };
            }

            // lodash (_ ) metodları (_ yazıldığında veya _. yazıldığında)
            const lodashMatch = lastWord === "_" || lastWord === "_.";
            if (lodashMatch) {
                return {
                    suggestions: [
                        {
                            label: "map",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "map(${1:array}, ${2:iteratee})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Diziyi dönüştürür",
                            documentation: "Dizinin her elemanını fonksiyon ile dönüştürür",
                        },
                        {
                            label: "filter",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "filter(${1:array}, ${2:predicate})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Diziyi filtreler",
                            documentation: "Koşula uyan elemanları döndürür",
                        },
                        {
                            label: "find",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "find(${1:array}, ${2:predicate})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Eleman bulur",
                            documentation: "Koşula uyan ilk elemanı döndürür",
                        },
                        {
                            label: "groupBy",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "groupBy(${1:array}, ${2:key})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Gruplandır",
                            documentation: "Diziyi belirtilen anahtara göre gruplar",
                        },
                        {
                            label: "orderBy",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "orderBy(${1:array}, ${2:keys}, ${3:orders})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Sıralar",
                            documentation: "Diziyi belirtilen anahtara göre sıralar",
                        },
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:object}, ${2:path}, ${3:defaultValue})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Güvenli değer okuma",
                            documentation: "Nesnenin derinliğindeki değeri güvenli şekilde okur",
                        },
                        {
                            label: "uniq",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "uniq(${1:array})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Tekil değerler",
                            documentation: "Dizideki tekrarlanan değerleri kaldırır",
                        },
                    ],
                };
            }

            // axios metodları (axios yazıldığında veya axios. yazıldığında)
            const axiosMatch = lastWord === "axios" || lastWord === "axios.";
            if (axiosMatch) {
                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:url}, ${2:config})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "HTTP GET isteği",
                            documentation: "GET isteği gönderir",
                        },
                        {
                            label: "post",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "post(${1:url}, ${2:data}, ${3:config})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "HTTP POST isteği",
                            documentation: "POST isteği gönderir",
                        },
                        {
                            label: "put",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "put(${1:url}, ${2:data}, ${3:config})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "HTTP PUT isteği",
                            documentation: "PUT isteği gönderir",
                        },
                        {
                            label: "delete",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "delete(${1:url}, ${2:config})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "HTTP DELETE isteği",
                            documentation: "DELETE isteği gönderir",
                        },
                    ],
                };
            }

            // supsis.module. için hem "list" metodu hem de dinamik modüller
            const modulePrefixMatch = lastWord.match(/^supsis\.module\.?$/);
            if (modulePrefixMatch) {
                const moduleSuggestions = [
                    {
                        label: "list",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "list()",
                        detail: "Tüm modülleri listeler",
                        documentation: "Sistemdeki tüm erişilebilir modüllerin listesini döndürür",
                    },
                ];

                (moduleCache || [])
                    .filter((m) => m.type === "module" && m.apiName && _.get(m, "module.settings.apiEnabled", true))
                    .forEach((m) => {
                        moduleSuggestions.push({
                            label: m.apiName,
                            kind: monaco.languages.CompletionItemKind.Module,
                            insertText: m.apiName,
                            detail: `${m.displayName || m.moduleName} Modülü`,
                            documentation: `${m.description || "Modül Erişimi"}`,
                        });
                    });
                return { suggestions: moduleSuggestions };
            }

            // Dinamik modüller için metodları göster
            const moduleInstanceMatch = lastWord.match(/^supsis\.module\.([a-zA-Z0-9_]+)\.?$/);
            console.log("createCompletionItemProvider-> moduleInstanceMatch", moduleInstanceMatch);
            if (moduleInstanceMatch) {
                const moduleApiName = moduleInstanceMatch[1];

                // list özel bir metod olduğu için kontrol et
                if (moduleApiName === "list") {
                    return {
                        suggestions: [],
                    };
                }

                // Seçilen modülün bilgilerini bul
                let selectedModule = null;
                let fieldSnippets = "";

                try {
                    // Store'dan modülü ve alanlarını bul
                    const modules = store.state.module.modules || [];
                    selectedModule = modules.find((m) => m.apiName === moduleApiName && m.type === "module");
                    console.log("createCompletionItemProviderForChatbot-> selectedModule", {
                        selectedModule,
                        moduleApiName,
                    });
                    if (selectedModule && selectedModule.module && selectedModule.module.table) {
                        const tableFields =
                            store.state.table.tables.find((t) => t._id === selectedModule.module.table)?.fields || [];
                        const tableId = selectedModule.module.table;
                        if (tableFields.length === 0) {
                            const table = tables.find((t) => t._id === tableId);
                            if (table) {
                                tableFields = table.fields || [];
                            }
                        }
                        console.log("createCompletionItemProviderForChatbot-> tableFields", {
                            selectedModule,
                            moduleApiName,
                            tableFields,
                        });

                        // API adı olan alanları snippet için hazırla
                        const fieldsWithApiName = tableFields.filter((field) => !!field.apiName);
                        console.log("createCompletionItemProviderForChatbot-> fieldsWithApiName", { fieldsWithApiName });
                        if (fieldsWithApiName.length > 0) {
                            console.log("createCompletionItemProviderForChatbot-> girdi ", { fieldsWithApiName });
                            fieldSnippets = fieldsWithApiName
                                .map((field) => `\t${field.apiName}: ${getDefaultValueByType(field.fieldType)}`)
                                .join(",\n");

                            console.log(`createCompletionItemProviderForChatbot ${moduleApiName} modülü için ${fieldsWithApiName.length} alan bulundu.`);
                        }
                    }
                } catch (error) {
                    console.error(`Modül alanları alınırken hata:`, error);
                }
                console.log("createCompletionItemProviderForChatbot-> fieldSnippets before ", { fieldSnippets });

                // Alan snippet'i oluşturulamadıysa varsayılanı kullan
                if (!fieldSnippets) {
                    fieldSnippets = "\t${1:field}: ${2:value}";
                }
                console.log("createCompletionItemProviderForChatbot-> fieldSnippets after ", { fieldSnippets });

                return {
                    suggestions: [
                        {
                            label: "get",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "get(${1:id})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kayıt getirir",
                            documentation: `${moduleApiName} modülünden ID'ye göre kayıt getirir`,
                        },
                        {
                            label: "create",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: `create({\n${fieldSnippets}\n})`,
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Yeni kayıt oluşturur",
                            documentation: `${moduleApiName} modülüne yeni kayıt ekler`,
                        },
                        {
                            label: "update",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: `update(\${1:id}, {\n${fieldSnippets}\n})`,
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kayıt günceller",
                            documentation: `${moduleApiName} modülündeki bir kaydı günceller`,
                        },
                        {
                            label: "delete",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: `delete(\${1:id})`,
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kayıt siler",
                            documentation: `${moduleApiName} modülündeki bir kaydı siler`,
                        },
                        {
                            label: "search",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText:
                                "search({\n\tfilters: ${1:[]},\n\tsort: ${2:{}},\n\tcursor: ${3:{ page: 1, perPage: 20 }}\n})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Kayıtları filtreler ve arar",
                            documentation: `${moduleApiName} modülündeki kayıtları filtreler ve listeler`,
                        },
                    ],
                };
            }

            // Üçüncü seviye tamamlamalar için - get metodu sonrası
            const thirdLevelMatch = lastWord.match(
                /^supsis\.(users|ticket|task|contact|whatsapp|chat|message|sms|email|report|module\.[a-zA-Z0-9_]+)\.(get|list|create|update|search)\.?$/
            );
            if (thirdLevelMatch) {
                // Metod çağrısı sonrası tamamlamalar için basit öneriler
                return {
                    suggestions: [
                        {
                            label: "then",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "then(function(result) {\n\t${1:// İşlem başarılı}\n\treturn result;\n})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Promise başarı işleyicisi",
                            documentation: "İşlem başarılı olduğunda çalışacak fonksiyon",
                        },
                        {
                            label: "catch",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "catch(function(error) {\n\t${1:// Hata oluştu}\n\tconsole.error(error);\n})",
                            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                            detail: "Promise hata işleyicisi",
                            documentation: "İşlemde hata oluştuğunda çalışacak fonksiyon",
                        },
                    ],
                };
            }

            // Global değişkenleri her durumda önermek için (eğer başka eşleşme yoksa)
            const allGlobalSuggestions = [
                {
                    label: "chatbot",
                    kind: monaco.languages.CompletionItemKind.Variable,
                    insertText: "chatbot",
                    detail: "Chatbot SDK",
                    documentation: "Chatbot özel metodları (sendMessage, close, transfer, readAttribute, vb.)",
                    sortText: "0_chatbot",
                },
                {
                    label: "supsis",
                    kind: monaco.languages.CompletionItemKind.Variable,
                    insertText: "supsis",
                    detail: "Supsis SDK",
                    documentation: "Supsis platform API (users, contact, task, module, vb.)",
                    sortText: "0_supsis",
                },
                {
                    label: "moment",
                    kind: monaco.languages.CompletionItemKind.Variable,
                    insertText: "moment",
                    detail: "Moment.js",
                    documentation: "Tarih ve saat işlemleri kütüphanesi",
                    sortText: "1_moment",
                },
                {
                    label: "_",
                    kind: monaco.languages.CompletionItemKind.Variable,
                    insertText: "_",
                    detail: "Lodash",
                    documentation: "Veri işleme kütüphanesi",
                    sortText: "1_lodash",
                },
                {
                    label: "axios",
                    kind: monaco.languages.CompletionItemKind.Variable,
                    insertText: "axios",
                    detail: "Axios",
                    documentation: "HTTP client",
                    sortText: "1_axios",
                },
            ];

            // lastWord ile eşleşenleri filtrele
            if (lastWord) {
                const filtered = allGlobalSuggestions.filter((s) =>
                    s.label.toLowerCase().startsWith(lastWord.toLowerCase())
                );
                if (filtered.length > 0) {
                    return { suggestions: filtered };
                }
            }

            return { suggestions: [] };
        },
    };
};
// Field türüne göre varsayılan değer önerileri oluşturmak için yardımcı fonksiyon
const getDefaultValueByType = (fieldType) => {
    switch (fieldType) {
        case "text":
        case "long-text":
        case "email":
        case "phone":
        case "url":
        case "color":
            return '"${1:value}"';
        case "number":
        case "currency":
            return "${1:0}";
        case "datetime":
            return "new Date()";
        case "checkbox":
            return "${1:false}";
        case "dropdown":
            return '"${1:option}"';
        case "json":
            return '{ ${1:key}: "${2:value}" }';
        default:
            return "${1:null}";
    }
};